import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from '../features/Dashboard/DashboardSlice';
import authReducer from './Slices/AuthSlice';
import fileReducer from './Slices/FileSlice';
import issuesReducer from "./Slices/IssuesSlice";
import maintenanceReducer from './Slices/MaintenanceSlice';
import permissionReducer from './Slices/PermissionSlice';
import serviceReducer from './Slices/ServiceSlice';
import tyreReducer from './Slices/TyreSlice';
import userReducer from './Slices/UserSlice';
import workOrderReducer from './Slices/WorkOrderSlice';
import notificationReducer from './Slices/NotificationSlice';
import tripReducer from "./Slices/TripSlice";
import dropdownReducer from "./Slices/dropdownSlice";
import fuelReducer from "./Slices/FuelSlice";
import partsReducer from "./Slices/PartsSlice";
import partVendorReducer from "./Slices/PartVendorSlice";
import procurementReducer from "./Slices/ProcurementSlice";
import fuelStationReducer from "./Slices/FuelStationSlice";
import categoryReducer from "./Slices/CategorySlice";
import equipmentReducer from "./Slices/EquipmentSlice";
import vehicleTypeReducer from "./Slices/VehicleTypeSlice";
import vehicleDropdownReducer from "./Slices/VehicleDropdownSlice";
import transporterReducer from "./Slices/TransporterSlice";
import customerReducer from "./Slices/CustomerSlice";
import partModelReducer from "./Slices/PartModelSlice";
import partMakeReducer from "./Slices/PartMakeSlice";
import loadBookingReducer from "./Slices/LoadBookingSlice";
import driverReducer from "./Slices/DriverSlice";
import vehicleTrackingReducer from "./Slices/VehicleTrackingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    maintenance: maintenanceReducer,
    tyre: tyreReducer,
    users: userReducer,
    permissions: permissionReducer,
    services: serviceReducer,
    files: fileReducer,
    issues: issuesReducer,
    workOrder: workOrderReducer,
    notifications: notificationReducer,
    trips: tripReducer,
    dropdowns: dropdownReducer,
    fuel: fuelReducer,
    parts: partsReducer,
    partVendors: partVendorReducer,
    procurement: procurementReducer,
    fuelStation: fuelStationReducer,
    categories: categoryReducer,
    equipment: equipmentReducer,
    vehicleTypes: vehicleTypeReducer,
    vehicleDropdowns: vehicleDropdownReducer,
    transporter: transporterReducer,
    customer: customerReducer,
    loadBooking: loadBookingReducer,
    partModels: partModelReducer,
    partMakes: partMakeReducer,
    drivers: driverReducer,
    vehicleTracking: vehicleTrackingReducer,
  },
});


